import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import type { TestIds } from '../../../../utils/testing.ts'
import { Text } from '../../../text/text.tsx'

export type CardHeadingOverlineProps = PropsWithChildren<
  TestIds & { className?: string }
>

export const CardHeadingOverline = ({
  children,
  className,
  ...testIds
}: CardHeadingOverlineProps) => {
  return typeof children === 'string' ? (
    <Text
      fontSize="xs"
      textColor="info"
      className={cn('uppercase', className)}
      {...testIds}
    >
      {children}
    </Text>
  ) : (
    children
  )
}
